import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { AvatarItemProps } from './types/avatarItemProps'

export const AvatarItem = styled.div<AvatarItemProps>`
  position: relative;
  z-index: ${({ zIndex }) => zIndex};

  &:not(:first-of-type) {
    margin-left: -${Spacing.S8};
  }
`

export const OverflowButton = styled.button`
  display: block;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  line-height: 0;
  cursor: pointer;
`
